const token = window.localStorage.getItem("proxyUniqueId");
const initialState = {
    idMenu: Number(token)
};

export const proxyReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case "UPDATE_ID":
            return {
                idMenu: payload
            };
        default:
            return state;
    }
};